
import { useChargeWaiverRegistrationVM } from "presentation/hook/ChargeWaiverRegistration/useChargeWaiverRegistrationVM";
import { useChargeWaiverRegistrationTracked } from "presentation/store/ChargeWaiverRegistration/ChargeWaiverRegistrationProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import ChargeWaiverRegistrationEditPanel from "./ChargeWaiverRegistrationEditPanel";
import ChargeWaiverRegistrationTablePanel from "./ChargeWaiverRegistrationTablePanel";

export const ChargeWaiverRegistrationMaintenance: React.FC = () => {
    const [chargeWaiverRegistrationState] = useChargeWaiverRegistrationTracked();
    const chargeWaiverRegistrationVM = useChargeWaiverRegistrationVM();
    const { isShowEditPanel } = chargeWaiverRegistrationState;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    chargeWaiverRegistrationVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {
                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            chargeWaiverRegistrationVM.onSearch().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [chargeWaiverRegistrationVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {isShowEditPanel && <ChargeWaiverRegistrationEditPanel />}
            {!isShowEditPanel && <SliderPanel
                isOpen={true}
                leftSectionWidth={'100%'}
                rightSectionWidth={"0%"}
                draggable={false}
                leftChildren={<ChargeWaiverRegistrationTablePanel />}
            />}
        </div>
    </>
}